// extracted by mini-css-extract-plugin
module.exports = {"Input":"Search-Input-32slpn","Wrapper":"Search-Wrapper-2rI02g","ImageWrapper":"Search-ImageWrapper-3pRCkP"};